import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SortingDirection } from './models/SortingDirection';
import SortingItemDescriptor from './models/SortingItemDescriptor';
import styles from './sortingMenuItem.module.scss';
import { SortingMode } from './models/SortingMode';

type Props = {
  item: SortingItemDescriptor;
  onSortingClick: (name: string, direction: SortingDirection) => void;
  sortingMenuRef: React.MutableRefObject<any>;
}

const SortingMenuItem = ({ item, onSortingClick, sortingMenuRef }: Props) => {
  // translations
  const tLabels = useTranslation(item.translationPath ?? "").t;

  // helpers
  const getActiveItemClass = (descriptor: SortingItemDescriptor, direction?: SortingDirection) => { 

    if (descriptor.active && descriptor.sortMode === SortingMode.Other) {
      return " text-primary";
    }

    if (descriptor.active && descriptor.sortMode === SortingMode.Direction && descriptor.direction === direction) {
      return " text-primary";
    }

    return "";
  }
  
  const sortingArrowClickHandler = (direction?: SortingDirection) => { 
    onSortingClick(item.name, direction!);
    sortingMenuRef.current.click();
  }

  const getTranslatedLabel = () => {
    if (item.translationPath) {
      return tLabels(item.label);
    }

    return item.label;
  }

  const sortMode = item.sortMode ?? SortingMode.Direction;
  const showDirection = sortMode === SortingMode.Direction;

  // render
  return (
    <div className='py-1 px-3'>
      <div className="d-flex align-items-center justify-content-between">
        <div
          className={!showDirection ? getActiveItemClass(item) : ""}
          onClick={!showDirection ? () => sortingArrowClickHandler() : undefined}
          role="button"
        >
          {getTranslatedLabel()}
        </div>
        {showDirection && (
          <div>
            <div className="d-flex ml-4">
              <span 
                onClick={() => sortingArrowClickHandler("ASC")}
                className={`${styles.sortingArrow}${getActiveItemClass(item, "ASC")}`}
                role="button"
              >
                <FontAwesomeIcon icon="long-arrow-alt-up" />
              </span>
              <span 
                onClick={() => sortingArrowClickHandler("DESC")}
                className={`ml-1 ${styles.sortingArrow}${getActiveItemClass(item, "DESC")}`}
                role="button"
              >
                <FontAwesomeIcon icon="long-arrow-alt-down" />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default SortingMenuItem;